// @flow
import { loaded } from '../middleware/apiCacheValidators';
import { Epoch, EpochList } from '../schema';
import { normalizeMetaItem, normalizeMetaList } from '../schema/normalizeMeta';

import type { Request } from './types';

export type LoadEpochsAction = { type: 'FETCH_EPOCHS' } & Request;
export type LoadEpochAction = { type: 'FETCH_EPOCH' } & Request;
export type EpochAction = LoadEpochsAction | LoadEpochAction;

export function loadEpochs(): LoadEpochsAction {
  return {
    type: 'FETCH_EPOCHS',
    IDAGIO_REQUEST: {
      type: 'API_REQUEST',
      method: 'GET',
      endpoint: '/v2.0/metadata/epochs',
    },
    meta: {
      schema: EpochList,
      normalize: normalizeMetaList,
    },
    cache: {
      fetch: state => state.lists.epochs,
      validate: loaded,
    },
  };
}

export function loadEpoch(id: string): LoadEpochAction {
  return {
    type: 'FETCH_EPOCH',
    cacheId: id,
    IDAGIO_REQUEST: {
      type: 'API_REQUEST',
      method: 'GET',
      endpoint: '/v2.0/metadata/epochs/{id}',
      params: { id },
    },
    meta: {
      schema: Epoch,
      normalize: normalizeMetaItem,
    },
    cache: {
      fetch: state => state.maps.epochs[id],
      validate: loaded,
    },
  };
}
